import BaseModel from './BaseModel'

export default class companyEmailaddress extends BaseModel {
  static entity = 'companies_emailaddresses'

  static primaryKey = ['company_id', 'emailaddress_id']

  static fields() {
    return {
      company_id: this.attr(null),
      emailaddress_id: this.attr(null),
    }
  }

  static methodConf = {
    methods: {
      $delete: {
        name: 'delete',
        http: {
          url: '/:company_id/:emailaddress_id/',
          method: 'delete',
        },
      },
    },
  }
}
